module.exports = __webpack_public_path__ + "static/img/gggggg_28.fd57908.png";


//////////////////
// WEBPACK FOOTER
// ./src/views/resources/images/icon/gggggg_28.png
// module id = VuMh
// module chunks = 1